// Shared helpers to keep service date selection consistent across booking forms.
// Dates are handled as local "YYYY-MM-DD" strings so they can be compared directly
// and assigned to <input type="date"> min/max/value attributes.

export const toDateStr = (date) => {
    if (!date) return ""
    return date.toLocaleString('sv', { timeZoneName: 'short' }).substring(0, 10)
}

// iOS Safari does not enforce the min/max attributes of a native date picker,
// so any selected date must be clamped back into the allowed range manually.
export const clampServiceDate = (value, minDate, maxDate) => {
    if (!value) return minDate || ""
    if (minDate && value < minDate) return minDate
    if (maxDate && value > maxDate) return maxDate
    return value
}

export const isServiceDateOutOfRange = (value, minDate, maxDate) => {
    if (!value) return true
    if (minDate && value < minDate) return true
    if (maxDate && value > maxDate) return true
    return false
}

// Criteria codes the date step writes: date, time slot, "skipped" (PT)
const DATE_TIME_CODES = [99, 100, 101]

// Puts the date step's entries into the booking criteria, replacing the ones a
// previous Next added (Back then Next again used to append a second pair, and
// the request went out with every date and slot the customer had tried).
// Edits the array in place, as the date steps always have: a new array from
// setRequestCriteria would re-run the hidden date step's price effect and
// flash its loading cover over the next step.
export const setDateTimeCriteria = (requestCriteria, ...entries) => {
    for (let i = requestCriteria.length - 1; i >= 0; i--) {
        if (DATE_TIME_CODES.some((code) => requestCriteria[i]?.[code] !== undefined)) {
            requestCriteria.splice(i, 1)
        }
    }
    requestCriteria.push(...entries)
}
